export default __webpack_public_path__ + "static/media/apple.15f01eef.svg";